import { useQuery } from '@tanstack/react-query';
import { SystemService } from '../api';

export const useSystemHealth = (enabled = true) => {
  return useQuery({
    queryKey: ['system', 'health'],
    queryFn: SystemService.getSystemHealth,
    enabled,
    refetchInterval: 30000, // Refresh every 30 seconds
    staleTime: 15000, // Consider stale after 15 seconds
    retry: 1, // Only retry once on failure
  });
};

export const useProcessingHealth = (enabled = true) => {
  return useQuery({
    queryKey: ['system', 'processing'],
    queryFn: SystemService.getProcessingHealth,
    enabled,
    refetchInterval: 30000, // Refresh every 30 seconds
    staleTime: 15000, // Consider stale after 15 seconds
    retry: 1,
  });
};
